"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeCarDriversListWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var commonFunctions_1 = require("../../commonFunctions");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var journey_services_1 = require("@ferry/journey-services");
var ConfirmModal_1 = require("../../components/modals/ConfirmModal");
var ChangeCarDriversListWidget = /** @class */ (function (_super) {
    __extends(ChangeCarDriversListWidget, _super);
    function ChangeCarDriversListWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.initialDriversList = [_this.props.interaction.policyHolder].concat(_this.props.interaction.additionalDrivers || []);
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.showDriverCheckbox = _this.getSetting("showDriverCheckbox", undefined) === true;
        var vehicle = _this.props.interaction.vehicles[_this.vehicleIndex];
        _this.state = {
            vehicle: vehicle,
            drivers: vehicle.driverIds.map(function (driverId) { return _this.initialDriversList.find(function (driver) { return driverId === driver.personId; }); }),
            showRemoveDriverConfirmation: false
        };
        _this.handleOnClickEvent = _this.handleOnClickEvent.bind(_this);
        _this.addDriver = _this.addDriver.bind(_this);
        _this.deleteDriver = _this.deleteDriver.bind(_this);
        _this.removeDriver = _this.removeDriver.bind(_this);
        _this.isPolicyHolder = _this.isPolicyHolder.bind(_this);
        return _this;
    }
    ChangeCarDriversListWidget.prototype.renderInputField = function () {
        var _this = this;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var vehicleInformation = "".concat(vehicle.make, " ").concat(vehicle.model, " ").concat(vehicle.registrationNumber);
        var vehicleRegNumber = '';
        if (vehicle.registrationNumber) {
            vehicleRegNumber = '(' + vehicle.registrationNumber + ')';
        }
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "falcon-checkbox form-group checkbox-margin-top-20 driver-list-wdg", children: [(0, jsx_runtime_1.jsx)("label", { className: "no-outline", children: "Drivers of ".concat(vehicle.make, ", ").concat(vehicle.model, " ").concat(vehicleRegNumber) }), (0, jsx_runtime_1.jsx)("div", { role: "group", "aria-label": "Who are the drivers of this ".concat((0, commonFunctions_1.trimParenthesesFromString)(vehicleInformation)), children: this.renderDrivers() }), this.props.interaction.additionalDrivers.length < 5 &&
                        (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "add-another-driver pt-3", to: "/journey/init/product/".concat(journey_services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaAddPermanentDriver/preset/").concat(this.props.interaction._id), children: "Add another driver" }), this.state.showRemoveDriverConfirmation &&
                        (0, jsx_runtime_1.jsx)(ConfirmModal_1.default, { show: this.state.showRemoveDriverConfirmation, onHide: function () { return _this.setState({
                                showRemoveDriverConfirmation: false,
                                removeDriverIndex: undefined
                            }); }, onConfirm: this.removeDriver, confirmButtonText: "Yes, please", children: (0, jsx_runtime_1.jsx)("div", { className: "fs-20 font-weight-medium font-family-display", children: "Are you sure you want to remove this driver?" }) })] }) }));
    };
    ChangeCarDriversListWidget.prototype.renderDrivers = function () {
        var _this = this;
        return this.initialDriversList
            .map(function (driver, index) {
            return (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [_this.showDriverCheckbox &&
                        (0, jsx_runtime_1.jsxs)("div", { className: "form-check mr-3", onClick: _this.handleOnClickEvent, children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(_this.isChecked(driver.personId)), type: "checkbox", "aria-label": _this.getSetting("ariaLabel", ""), onChange: _this.handleOnClickEvent, value: driver.personId, onDoubleClick: _this.executeNativeEvent, name: driver.firstName, id: _this.props.question.name + driver.personId, disabled: index === 0, checked: _this.isChecked(driver.personId) }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: _this.props.question.name + driver.personId, children: (0, jsx_runtime_1.jsx)("div", { id: driver.personId, className: "checkbox-big ".concat(_this.isPolicyHolder(driver)) }) })] }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-0 driver-name", children: [driver.firstName, " ", driver.lastName] }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "ml-2 pt-1 edit-driver-link", id: "editDriver".concat(index === 0 ? "PolicyHolder" : index - 1), to: "/journey/init/product/".concat(journey_services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaEditDriverDetails/presetDriver").concat(index === 0 ? "PolicyHolder" : index - 1, "/").concat(_this.props.interaction._id), children: "Edit" }), (index > 0) &&
                        (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "ml-2 pt-1 edit-driver-link remove-driver", to: '#', id: "removeDriver".concat(index === 0 ? "PolicyHolder" : index - 1), onClick: function () {
                                _this.setState({ showRemoveDriverConfirmation: true, removeDriverIndex: index - 1 });
                            }, children: "/ remove" })] }, driver.personId);
        });
    };
    ChangeCarDriversListWidget.prototype.removeDriver = function () {
        window.location.href = "/journey/show/product/".concat(journey_services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaRemoveDriver/removeDriver").concat(this.state.removeDriverIndex, "EntryPage/").concat(this.props.interaction._id);
        this.setState({ showRemoveDriverConfirmation: false, removeDriverIndex: undefined });
    };
    ChangeCarDriversListWidget.prototype.isPolicyHolder = function (driver) {
        return driver.personId === this.props.interaction.policyHolder.personId ? "disabled" : "";
    };
    ChangeCarDriversListWidget.prototype.handleOnClickEvent = function (event) {
        var _this = this;
        event.preventDefault();
        var changeDriverId = event.target.id;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        if (changeDriverId === vehicle.mainDriverId || changeDriverId === this.props.interaction.policyHolder.personId) {
            return;
        }
        var changed = false;
        if (vehicle.driverIds.length > 1) {
            vehicle.driverIds.forEach(function (driverId) {
                if (driverId === changeDriverId) {
                    _this.deleteDriver(changeDriverId);
                    changed = true;
                }
            });
        }
        if (!changed && !this.state.vehicle.driverIds.includes(changeDriverId)) {
            this.addDriver(changeDriverId);
        }
    };
    ChangeCarDriversListWidget.prototype.deleteDriver = function (driverPersonId) {
        var _a = this.state, vehicle = _a.vehicle, drivers = _a.drivers;
        var driverIdIndex = vehicle.driverIds.findIndex(function (id) { return id.localeCompare(driverPersonId) === 0; });
        if (driverIdIndex > -1) {
            vehicle.driverIds.splice(driverIdIndex, 1);
        }
        var driverIndex = drivers.findIndex(function (driver) { return driver.personId.localeCompare(driverPersonId) === 0; });
        if (driverIndex > -1) {
            drivers.splice(driverIndex, 1);
        }
        if (!vehicle.driverIds.includes(vehicle.mainDriverId)) {
            vehicle.mainDriverId = vehicle.driverIds[0];
        }
        vehicle.numberOfDrivers -= 1;
        this.setState({
            vehicle: vehicle,
            drivers: drivers
        });
        this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "]"), this.state.vehicle);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(this.vehicleIndex, "]"));
        var additionalDrivers = this.props.interaction.additionalDrivers;
        var additionalDriverIndex = additionalDrivers.findIndex(function (driver) { return driver.personId.localeCompare(driverPersonId) === 0; });
        if (additionalDriverIndex > -1) {
            additionalDrivers.splice(additionalDriverIndex, 1);
        }
        this.props.onStateChange("additionalDrivers", additionalDrivers);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "additionalDrivers");
    };
    ChangeCarDriversListWidget.prototype.addDriver = function (driverPersonId) {
        var _a = this.state, vehicle = _a.vehicle, drivers = _a.drivers;
        vehicle.driverIds.push(driverPersonId);
        vehicle.numberOfDrivers += 1;
        this.setState({
            vehicle: vehicle,
            drivers: drivers
        });
        this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "]"), this.state.vehicle);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(this.vehicleIndex, "]"));
        var additionalDrivers = this.props.engine.getInteraction().additionalDrivers;
        additionalDrivers.push(this.initialDriversList.find(function (driver) { return driver.personId === driverPersonId; }));
        this.props.onStateChange("additionalDrivers", additionalDrivers);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "additionalDrivers");
    };
    ChangeCarDriversListWidget.prototype.isChecked = function (checkedDriverId) {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var result = false;
        vehicle.driverIds.forEach(function (driverId) {
            if (driverId === checkedDriverId) {
                result = true;
            }
        });
        return result;
    };
    return ChangeCarDriversListWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.ChangeCarDriversListWidget = ChangeCarDriversListWidget;
//# sourceMappingURL=ChangeCarDriversListWidget.js.map